import ChannelLabel from '@op/components/ChannelLabel';
import { LocaleType } from '@op/types/common';
import React, { Fragment } from 'react';
import { getLocale } from 'umi';

export default function ChannelShow({
  title,
  channelList,
  endText,
}: {
  title: string;
  channelList: Array<any>;
  endText?: any;
}) {
  const symbolMap: { [key in LocaleType]: [string, string] } = {
    'en-US': [',', '.'],
    'zh-CN': ['，', '。'],
  };
  const lang: LocaleType = getLocale();
  const symbolList = symbolMap[lang];

  return (
    <div className="dbo-monitoring-chanel-show">
      <h2 className="dbo-monitoring-scope-subtitle">{title}</h2>
      <div>
        {channelList.map((item, index) => {
          const isString = typeof item === 'string';
          const channelProps = isString ? { channel_name: item } : item;
          return (
            <label
              className={`channel-label-box ${lang === 'en-US' ? 'en' : 'zh'}`}
              key={index}
            >
              <ChannelLabel
                showText
                key={index}
                {...channelProps}
              ></ChannelLabel>
              {index < channelList.length - 1 ? symbolList[0] : symbolList[1]}
            </label>
          );
        })}{' '}
        {endText}
      </div>
    </div>
  );
}
